namespace $ {

	export type $shm_agent_activity_phase = 'unknown' | 'starting' | 'active' | 'idle'

	export class $shm_agent_state extends $mol_object2 {

		@ $mol_mem
		thread_revision( next?: number ) {
			return next ?? 0
		}

		@ $mol_mem
		activity( next?: $shm_agent_activity_phase ) {
			return next ?? 'unknown'
		}

		activity_busy( summary_active = false ) {
			switch( this.activity() ) {
				case 'starting':
				case 'active': return true
				case 'idle': return false
				default: return summary_active
			}
		}

		activity_start() {
			return this.activity( 'starting' )
		}

		activity_confirm( active: boolean ) {
			return this.activity( active ? 'active' : 'idle' )
		}

		activity_reset() {
			return this.activity( 'unknown' )
		}

		activity_snapshot( active: boolean ) {
			if( !active && this.activity() === 'starting' ) return this.activity()
			return this.activity_confirm( active )
		}

		activity_event( event: any ) {
			const method = String( event?.method || '' )
			const params = event?.params ?? {}
			if( method === 'thread/activity/changed' ) {
				return this.activity_confirm( Boolean( params.active ) )
			}
			if( method === 'turn/started' || method === 'item/started' ) {
				return this.activity_confirm( true )
			}
			if( method === 'thread/status/changed' ) {
				if( params.status?.type === 'active' ) return this.activity_confirm( true )
				if( params.activityCanonical ) return this.activity()
				if( [ 'idle', 'systemError' ].includes( params.status?.type ) ) return this.activity_confirm( false )
			}
			if( method === 'thread/file/updated' && 'activeTurnId' in params ) {
				if( params.activityCanonical && 'active' in params ) {
					return this.activity_confirm( Boolean( params.active ) )
				}
				return this.activity_confirm( Boolean( params.activeTurnId ) )
			}
			if( params.activityCanonical ) return this.activity()
			if( method === 'turn/completed' || ( method === 'error' && !params.willRetry ) ) {
				return this.activity_confirm( false )
			}
			return this.activity()
		}

		@ $mol_mem
		live_items( next?: Record< string, any > ) {
			return next ?? {}
		}

		@ $mol_mem
		attachments( next?: readonly $shm_agent_attachment[] ) {
			$mol_wire_solid()
			return next ?? []
		}

	}

}
